import fetcher from '../client';
import { Address } from '@peerless/data-access/cart-service/server';
import { FormErrors } from './types';

export const updateShippingAddress = (
  shippingAddress: Address
): Promise<{ errors: FormErrors }> => {
  return fetcher.post(`/cart/shipping-address`, { ...shippingAddress });
};
